import React from 'react';

const API = `${(process.env.REACT_APP_BACKEND_URL || 'https://bobine.live')}/api`;

const CercleTab = ({
  familyCircle, setFamilyCircle, familyRole, setFamilyRole,
  familyInviteEmail, setFamilyInviteEmail, familyLoading, setFamilyLoading,
  familyMsg, setFamilyMsg, familySharedPhotos, setFamilySharedPhotos,
  currentPlan, navigate, token, t, sounds,
}) => {
  return (
    <div data-testid="cercle-familial-tab">
      {/* No circle yet — Create or Join */}
      {!familyCircle && (
        <div style={{ textAlign: 'center', padding: '60px 20px' }}>
          <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.2" style={{ margin: '0 auto 20px', opacity: 0.7 }}>
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          <h3 style={{ fontFamily: "'Georgia', serif", fontSize: 22, color: '#D4AF37', marginBottom: 12 }}>
            {t('family_title') || 'Cercle Familial'}
          </h3>
          <p style={{ fontFamily: "'Georgia', serif", fontSize: 14, color: '#FAF3E0', maxWidth: 440, margin: '0 auto 28px', lineHeight: 1.7 }}>
            {t('family_desc') || 'Invitez jusqu\'a 5 proches a consulter et alimenter votre Tronc Commun. Vos souvenirs prives restent prives.'}
          </p>
          {currentPlan === 'heritage' ? (
            <button
              data-testid="create-circle-btn"
              onClick={async () => {
                setFamilyLoading(true);
                try {
                  const res = await fetch(`${API}/family/create`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
                  const d = await res.json();
                  if (d.circle) { setFamilyCircle(d.circle); setFamilyRole('guardian'); setFamilyMsg({ type: 'success', text: 'Cercle cree !' }); sounds?.cristal?.(); }
                  else setFamilyMsg({ type: 'error', text: d.detail || 'Erreur' });
                } catch { setFamilyMsg({ type: 'error', text: 'Erreur reseau' }); }
                setFamilyLoading(false);
              }}
              disabled={familyLoading}
              style={{
                fontFamily: "'Georgia', serif", fontSize: 14, color: '#000',
                background: 'linear-gradient(145deg, #D4AF37, #B8860B)', border: 'none', padding: '12px 32px',
                borderRadius: 8, cursor: 'pointer', fontWeight: 600, letterSpacing: 0.5,
                opacity: familyLoading ? 0.5 : 1,
              }}
            >
              {familyLoading ? '...' : (t('family_create') || 'Creer mon Cercle Familial')}
            </button>
          ) : (
            <div>
              <p style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37', marginBottom: 16 }}>
                {t('family_heritage_required') || 'Le Cercle Familial est inclus dans l\'offre Heritage.'}
              </p>
              <button
                onClick={() => navigate('/offres')}
                data-testid="upgrade-heritage-btn"
                style={{
                  fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37',
                  backgroundColor: 'transparent', border: '1px solid rgba(212,175,55,0.3)',
                  padding: '10px 24px', borderRadius: 8, cursor: 'pointer',
                }}
              >
                {t('family_see_plans') || 'Decouvrir L\'Heritage'}
              </button>
            </div>
          )}
          {familyMsg && (
            <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, marginTop: 16, color: familyMsg.type === 'success' ? '#2ecc71' : '#e74c3c' }}>
              {familyMsg.text}
            </p>
          )}
        </div>
      )}

      {/* Guardian view — Manage circle */}
      {familyCircle && familyRole === 'guardian' && (() => {
        const memberCount = familyCircle.members?.length || 0;
        const maxMembers = familyCircle.max_members || 5;
        const fillPct = (memberCount / maxMembers) * 100;
        const remaining = maxMembers - memberCount;
        return (
        <div style={{ maxWidth: 640, margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
            <div>
              <h3 style={{ fontFamily: "'Georgia', serif", fontSize: 20, color: '#D4AF37', margin: 0 }}>
                {t('family_my_circle') || 'Mon Cercle Familial'}
              </h3>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{
                display: 'flex', alignItems: 'center', gap: 6, padding: '6px 14px',
                borderRadius: 20, border: '1px solid rgba(212,175,55,0.15)', backgroundColor: 'rgba(212,175,55,0.04)',
              }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                <span style={{ fontFamily: "'Georgia', serif", fontSize: 11, color: '#D4AF37' }}>
                  {familyCircle.guardian_id === familyCircle.co_guardian_id ? 'Gardien' :
                   (familyCircle.guardian_name?.split(' ')[0] || 'Gardien')}
                </span>
              </div>
              {familyCircle.co_guardian_name && (
                <div style={{
                  display: 'flex', alignItems: 'center', gap: 6, padding: '6px 14px',
                  borderRadius: 20, border: '1px solid rgba(212,175,55,0.15)', backgroundColor: 'rgba(212,175,55,0.04)',
                }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                  <span style={{ fontFamily: "'Georgia', serif", fontSize: 11, color: '#D4AF37' }}>
                    {familyCircle.co_guardian_name?.split(' ')[0]}
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Jauge doree — Places restantes */}
          <div data-testid="family-gauge" style={{
            padding: '20px 24px', borderRadius: 12, marginBottom: 24,
            background: 'linear-gradient(135deg, rgba(212,175,55,0.04), rgba(212,175,55,0.01))',
            border: '1px solid rgba(212,175,55,0.12)',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 10 }}>
              <span style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37' }}>
                {t('family_gauge_label') || 'Places dans votre ecrin'}
              </span>
              <span style={{ fontFamily: "'Georgia', serif", fontSize: 22, color: '#D4AF37', fontWeight: 600, letterSpacing: 1 }}>
                {memberCount}<span style={{ fontSize: 13, fontWeight: 400, color: '#D4AF37' }}>/{maxMembers}</span>
              </span>
            </div>
            <div style={{
              width: '100%', height: 8, borderRadius: 4, overflow: 'hidden',
              backgroundColor: 'rgba(212,175,55,0.08)', position: 'relative',
            }}>
              <div style={{
                width: `${fillPct}%`, height: '100%', borderRadius: 4,
                background: 'linear-gradient(90deg, #D4AF37, #F4D03F)',
                transition: 'width 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
                boxShadow: fillPct > 0 ? '0 0 12px rgba(212,175,55,0.4)' : 'none',
              }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, padding: '0 2px' }}>
              {Array.from({ length: maxMembers }, (_, i) => (
                <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                  <div style={{
                    width: 28, height: 28, borderRadius: '50%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    backgroundColor: i < memberCount ? 'rgba(212,175,55,0.15)' : 'rgba(255,255,255,0.03)',
                    border: `1.5px solid ${i < memberCount ? '#D4AF37' : 'rgba(255,255,255,0.08)'}`,
                    transition: 'all 0.5s',
                  }}>
                    {i < memberCount ? (
                      <span style={{ fontFamily: "'Georgia', serif", fontSize: 11, color: '#D4AF37', fontWeight: 600 }}>
                        {(familyCircle.members[i]?.name || '?')[0].toUpperCase()}
                      </span>
                    ) : (
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="2">
                        <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                      </svg>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <p style={{
              fontFamily: "'Georgia', serif", fontSize: 11, color: '#FAF3E0',
              textAlign: 'center', marginTop: 8, fontStyle: 'italic',
            }}>
              {remaining > 0
                ? `${remaining} ${remaining > 1 ? (t('family_seats_left') || 'places disponibles') : (t('family_seat_left') || 'place disponible')} dans votre ecrin`
                : (t('family_full') || 'Votre Cercle est au complet')
              }
            </p>
          </div>

          {/* Invite form */}
          {(familyCircle.members?.length || 0) < (familyCircle.max_members || 5) && (
            <div data-testid="family-invite-form" style={{
              padding: '20px 24px', borderRadius: 10, marginBottom: 24,
              backgroundColor: 'rgba(212,175,55,0.03)', border: '1px solid rgba(212,175,55,0.12)',
            }}>
              <p style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37', marginBottom: 12 }}>
                {t('family_invite_prompt') || 'Inviter un proche par email'}
              </p>
              <div style={{ display: 'flex', gap: 10 }}>
                <input
                  data-testid="family-invite-email"
                  type="email"
                  placeholder="email@exemple.com"
                  value={familyInviteEmail}
                  onChange={e => setFamilyInviteEmail(e.target.value)}
                  style={{
                    flex: 1, fontFamily: "'Georgia', serif", fontSize: 13,
                    backgroundColor: 'rgba(0,0,0,0.4)', border: '1px solid rgba(212,175,55,0.2)',
                    borderRadius: 6, padding: '10px 14px', color: '#fff', outline: 'none',
                  }}
                />
                <button
                  data-testid="family-invite-btn"
                  disabled={familyLoading || !familyInviteEmail}
                  onClick={async () => {
                    setFamilyLoading(true); setFamilyMsg(null);
                    try {
                      const res = await fetch(`${API}/family/invite`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                        body: JSON.stringify({ email: familyInviteEmail }),
                      });
                      const d = await res.json();
                      if (d.status === 'success') {
                        setFamilyMsg({ type: 'success', text: `Invitation envoyee a ${familyInviteEmail}` }); sounds?.cristal?.();
                        setFamilyInviteEmail('');
                      } else {
                        setFamilyMsg({ type: 'error', text: d.detail || 'Erreur' });
                      }
                    } catch { setFamilyMsg({ type: 'error', text: 'Erreur reseau' }); }
                    setFamilyLoading(false);
                  }}
                  style={{
                    fontFamily: "'Georgia', serif", fontSize: 13, color: '#000',
                    background: 'linear-gradient(145deg, #D4AF37, #B8860B)', border: 'none', padding: '10px 20px',
                    borderRadius: 6, cursor: 'pointer', fontWeight: 600,
                    opacity: (familyLoading || !familyInviteEmail) ? 0.4 : 1,
                  }}
                >
                  {familyLoading ? '...' : (t('family_invite_send') || 'Inviter')}
                </button>
              </div>
              {familyMsg && (
                <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, marginTop: 10, color: familyMsg.type === 'success' ? '#2ecc71' : '#e74c3c' }}>
                  {familyMsg.text}
                </p>
              )}
            </div>
          )}

          {/* Members list */}
          <div style={{ marginBottom: 28 }}>
            <h4 style={{ fontFamily: "'Georgia', serif", fontSize: 14, color: '#D4AF37', marginBottom: 14 }}>
              {t('family_members_title') || 'Membres du Cercle'}
            </h4>
            {(!familyCircle.members || familyCircle.members.length === 0) ? (
              <p style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#FAF3E0', fontStyle: 'italic', textAlign: 'center', padding: '24px 0' }}>
                {t('family_no_members') || 'Aucun membre pour l\'instant. Envoyez votre premiere invitation !'}
              </p>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {familyCircle.members.map(m => (
                  <div key={m.user_id} data-testid={`family-member-${m.user_id}`} style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '14px 18px', borderRadius: 8,
                    backgroundColor: 'rgba(212,175,55,0.03)', border: '1px solid rgba(212,175,55,0.08)',
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <div style={{
                        width: 36, height: 36, borderRadius: '50%', backgroundColor: 'rgba(212,175,55,0.1)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontFamily: "'Georgia', serif", fontSize: 14, color: '#D4AF37', fontWeight: 600,
                      }}>
                        {(m.name || '?')[0].toUpperCase()}
                      </div>
                      <div>
                        <p style={{ fontFamily: "'Georgia', serif", fontSize: 14, color: '#D4AF37', margin: 0 }}>{m.name}</p>
                        <p style={{ fontFamily: "'Georgia', serif", fontSize: 11, color: '#FAF3E0', margin: '2px 0 0' }}>{m.email}</p>
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ fontFamily: "'Georgia', serif", fontSize: 10, color: '#FAF3E0' }}>
                        {m.joined_at ? new Date(m.joined_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }) : ''}
                      </span>
                      <button
                        data-testid={`remove-member-${m.user_id}`}
                        onClick={async () => {
                          if (!window.confirm(`Retirer ${m.name} du Cercle ?`)) return;
                          try {
                            await fetch(`${API}/family/members/${m.user_id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
                            setFamilyCircle(prev => ({ ...prev, members: prev.members.filter(x => x.user_id !== m.user_id) }));
                          } catch { /* silent */ }
                        }}
                        style={{
                          fontFamily: "'Georgia', serif", fontSize: 11, color: '#FAF3E0',
                          backgroundColor: 'transparent', border: '1px solid rgba(255,255,255,0.08)',
                          borderRadius: 4, padding: '4px 10px', cursor: 'pointer',
                        }}
                      >
                        Retirer
                      </button>
                      <button
                        data-testid={`transfer-guardian-${m.user_id}`}
                        onClick={async () => {
                          const hasCo = !!familyCircle.co_guardian_id;
                          if (hasCo) {
                            if (!window.confirm(`Transferer le role de Gardien principal a ${m.name} ?`)) return;
                            try {
                              const res = await fetch(`${API}/family/transfer-guardian`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                                body: JSON.stringify({ new_guardian_id: m.user_id }),
                              });
                              if ((await res.json()).status === 'success') {
                                const circRes = await fetch(`${API}/family/circle`, { headers: { Authorization: `Bearer ${token}` } });
                                const circData = await circRes.json();
                                if (circData.circle) { setFamilyCircle(circData.circle); setFamilyRole(circData.circle.role); }
                              }
                            } catch { /* silent */ }
                          } else {
                            if (!window.confirm(`Nommer ${m.name} comme 2eme Gardien du Fil ?`)) return;
                            try {
                              const res = await fetch(`${API}/family/promote-co-guardian`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                                body: JSON.stringify({ member_id: m.user_id }),
                              });
                              if ((await res.json()).status === 'success') {
                                const circRes = await fetch(`${API}/family/circle`, { headers: { Authorization: `Bearer ${token}` } });
                                const circData = await circRes.json();
                                if (circData.circle) { setFamilyCircle(circData.circle); setFamilyRole(circData.circle.role); }
                              }
                            } catch { /* silent */ }
                          }
                        }}
                        title={familyCircle.co_guardian_id
                          ? (t('family_transfer') || 'Transferer le role de Gardien')
                          : (t('family_promote_co') || 'Nommer 2eme Gardien du Fil')
                        }
                        style={{
                          fontFamily: "'Georgia', serif", fontSize: 11, color: '#D4AF37',
                          backgroundColor: 'transparent', border: '1px solid rgba(212,175,55,0.08)',
                          borderRadius: 4, padding: '4px 8px', cursor: 'pointer',
                        }}
                      >
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Tronc Commun — Share photos */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
              <h4 style={{ fontFamily: "'Georgia', serif", fontSize: 14, color: '#D4AF37', margin: 0 }}>
                {t('family_tronc_commun') || 'Tronc Commun'} ({familyCircle.shared_photo_ids?.length || 0} {t('photos') || 'photos'})
              </h4>
              <button
                data-testid="manage-tronc-commun-btn"
                onClick={async () => {
                  try {
                    const res = await fetch(`${API}/family/shared-photos`, { headers: { Authorization: `Bearer ${token}` } });
                    const d = await res.json();
                    setFamilySharedPhotos(d.photos || []);
                  } catch { /* silent */ }
                }}
                style={{
                  fontFamily: "'Georgia', serif", fontSize: 11, color: '#D4AF37',
                  backgroundColor: 'transparent', border: '1px solid rgba(212,175,55,0.15)',
                  borderRadius: 4, padding: '4px 12px', cursor: 'pointer',
                }}
              >
                {t('family_refresh') || 'Actualiser'}
              </button>
            </div>
            <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#FAF3E0', lineHeight: 1.6, marginBottom: 16 }}>
              {t('family_tronc_desc') || 'Partagez des photos depuis l\'onglet "Mes Tresors" pour les rendre visibles a votre Cercle.'}
            </p>
            {familySharedPhotos.length > 0 && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))', gap: 8 }}>
                {familySharedPhotos.slice(0, 12).map(p => (
                  <div key={p.id} style={{ position: 'relative', aspectRatio: '1', borderRadius: 6, overflow: 'hidden', border: '1px solid rgba(212,175,55,0.1)' }}>
                    <img
                      src={`${API}/photos/${p.id}/thumbnail`}
                      alt=""
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={e => { e.target.style.display = 'none'; }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )})()}

      {/* Member view */}
      {familyCircle && familyRole === 'member' && (
        <div style={{ maxWidth: 640, margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 28 }}>
            <div>
              <h3 style={{ fontFamily: "'Georgia', serif", fontSize: 20, color: '#D4AF37', margin: 0 }}>
                {t('family_circle_of') || 'Cercle de'} {familyCircle.guardian_name}
              </h3>
              <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#FAF3E0', margin: '4px 0 0' }}>
                {t('family_member_label') || 'Vous etes membre'} — {familyCircle.members?.length || 0} {t('family_members') || 'membres'}
              </p>
            </div>
            <button
              data-testid="leave-circle-btn"
              onClick={async () => {
                if (!window.confirm('Quitter ce Cercle Familial ?')) return;
                try {
                  await fetch(`${API}/family/leave`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
                  setFamilyCircle(null); setFamilyRole(null);
                } catch { /* silent */ }
              }}
              style={{
                fontFamily: "'Georgia', serif", fontSize: 11, color: '#FAF3E0',
                backgroundColor: 'transparent', border: '1px solid rgba(255,255,255,0.1)',
                padding: '6px 14px', borderRadius: 6, cursor: 'pointer',
              }}
            >
              {t('family_leave') || 'Quitter le Cercle'}
            </button>
          </div>

          {/* Shared photos */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
              <h4 style={{ fontFamily: "'Georgia', serif", fontSize: 14, color: '#D4AF37', margin: 0 }}>
                {t('family_tronc_commun') || 'Tronc Commun'}
              </h4>
              <button
                data-testid="load-shared-photos-btn"
                onClick={async () => {
                  try {
                    const res = await fetch(`${API}/family/shared-photos`, { headers: { Authorization: `Bearer ${token}` } });
                    const d = await res.json();
                    setFamilySharedPhotos(d.photos || []);
                  } catch { /* silent */ }
                }}
                style={{
                  fontFamily: "'Georgia', serif", fontSize: 11, color: '#D4AF37',
                  backgroundColor: 'transparent', border: '1px solid rgba(212,175,55,0.15)',
                  borderRadius: 4, padding: '4px 12px', cursor: 'pointer',
                }}
              >
                {t('family_load_photos') || 'Charger les souvenirs'}
              </button>
            </div>
            {familySharedPhotos.length > 0 ? (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: 10 }}>
                {familySharedPhotos.map(p => (
                  <div key={p.id} style={{ position: 'relative', aspectRatio: '1', borderRadius: 8, overflow: 'hidden', border: '1px solid rgba(212,175,55,0.1)' }}>
                    <img
                      src={`${API}/photos/${p.id}/thumbnail`}
                      alt={p.caption || p.filename || ''}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <p style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#FAF3E0', fontStyle: 'italic', textAlign: 'center', padding: '40px 0' }}>
                {t('family_no_shared') || 'Le Gardien n\'a pas encore partage de souvenirs dans le Tronc Commun.'}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CercleTab;
